import React from "react";
import PeonyMark from "./PeonyMark";

/**
 * Editorial photo placeholder. Renders a refined frame in the requested aspect
 * with a soft peony watermark, an "Foto folgt" label and an optional caption.
 * Drop in `src` later and the placeholder disappears automatically.
 */
const PhotoPlaceholder = ({
  src,
  alt = "",
  aspect = "3/4",
  label = "Foto folgt",
  caption,
  position = "30% 30%",
  tone = "warm", // 'warm' | 'depth'
  className = "",
  testId,
}) => {
  if (src) {
    return (
      <figure
        data-testid={testId}
        className={`relative overflow-hidden bg-depth ${className}`}
        style={{ aspectRatio: aspect }}
      >
        <img
          src={src}
          alt={alt}
          className="absolute inset-0 w-full h-full object-cover"
          style={{ objectPosition: position }}
        />
        {caption && (
          <figcaption className="absolute left-5 bottom-5 right-5 text-canvas font-mono text-[0.6rem] tracking-[0.32em] uppercase">
            {caption}
          </figcaption>
        )}
      </figure>
    );
  }

  const bg =
    tone === "depth"
      ? "linear-gradient(170deg, #28001B 0%, #5C4752 100%)"
      : "linear-gradient(170deg, #CBB7B0 0%, #5C4752 110%)";

  const labelColor = tone === "depth" ? "text-warmth/80" : "text-canvas/90";

  return (
    <figure
      data-testid={testId}
      className={`relative overflow-hidden border border-warmth/40 ${className}`}
      style={{ aspectRatio: aspect, background: bg }}
    >
      <PeonyMark
        size={520}
        color={tone === "depth" ? "#FAF7F2" : "#28001B"}
        opacity={0.08}
        className="absolute -right-32 -bottom-32"
      />
      <div className="absolute inset-0 grain-light pointer-events-none" />
      <div className={`absolute inset-0 flex flex-col justify-between p-5 md:p-6 ${labelColor}`}>
        <span className="font-mono text-[0.6rem] tracking-[0.32em] uppercase">
          {label}
        </span>
        <div>
          {caption && (
            <p className="font-display italic text-xl md:text-2xl text-canvas leading-tight">
              {caption}
            </p>
          )}
          <p className="mt-2 font-mono text-[0.55rem] tracking-[0.32em] uppercase opacity-70">
            Patrice · Studio
          </p>
        </div>
      </div>
      {/* Crop guides */}
      <span className="absolute top-3 left-3 w-3 h-3 border-l border-t border-canvas/60" />
      <span className="absolute top-3 right-3 w-3 h-3 border-r border-t border-canvas/60" />
      <span className="absolute bottom-3 left-3 w-3 h-3 border-l border-b border-canvas/60" />
      <span className="absolute bottom-3 right-3 w-3 h-3 border-r border-b border-canvas/60" />
    </figure>
  );
};

export default PhotoPlaceholder;
